import { CmsPage } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.PRIVACYPOLICY.path,
      name: "Privacy Policy",
      key: routesMap.PRIVACYPOLICY.path,
      commonRoute: true,
      // private: false,
      // withAuth: true,
      // belongsToHeader: true,
      element: <CmsPage />,
    },
  ];
}
